module.exports = __webpack_public_path__ + "img/egg-mygallinas-icon.1117e207.svg";